<template>
    <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
        <div class="text-[#414141] font-sans">
            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">Overview</h3>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">In this module, you will finalize your budget by entering your organization’s total annual overhead expenses, justification for those expenses, and projected revenue. Estimate these overhead expenses and revenue for the next three years to create a clear financial snapshot and planning tool.</p>
           
        </div>
    </div>
</template>

<script setup>
import { useStepValidation } from '@/composables/useStepValidation';

// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style> 